{
  "schemaVersion": "qec-trace-0.3",
  "engineVersion": "1.0.0",
  "pathMapVersion": "qec-path-map-0.3.0",
  "manifestationVersion": "qec-manifestation-0.2",
  "program": "אור",
  "programHash": "fnv1a32-ddb3d910",
  "seed": 0,
  "initialState": [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    0
  ],
  "events": [
    {
      "sequence": 0,
      "instructionIndex": 0,
      "letter": "א",
      "transform": "preserve-frame",
      "route": [
        "Keter",
        "Tiferet"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "KeterService",
        "TiferetScheduler"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        0
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        0
      ],
      "beforeHash": "086f7eaa",
      "afterHash": "086f7eaa",
      "coherence": {
        "activation": 0.425,
        "phase": 3.173,
        "coherence": 0.885
      }
    },
    {
      "sequence": 1,
      "instructionIndex": 1,
      "letter": "ו",
      "transform": "mirror-exchange",
      "route": [
        "Hod",
        "Yesod"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "HodInterface",
        "YesodBus"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        0
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        0
      ],
      "beforeHash": "086f7eaa",
      "afterHash": "48dede44",
      "coherence": {
        "activation": 0.125,
        "phase": 2.634,
        "coherence": 0.635
      }
    },
    {
      "sequence": 2,
      "instructionIndex": 2,
      "letter": "ר",
      "transform": "seed-rotation",
      "route": [
        "Yesod",
        "Malchut"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "YesodBus",
        "MalchutOutput"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        0
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        0
      ],
      "beforeHash": "48dede44",
      "afterHash": "086f7eaa",
      "coherence": {
        "activation": 0.481,
        "phase": 4.495,
        "coherence": 0.896
      }
    }
  ],
  "completeTraceHash": "fnv1a32-90683d1e",
  "observation": {
    "step": 3,
    "reason": "program-end",
    "stateHash": "f184659e",
    "traceHash": "fnv1a32-90683d1e",
    "candidates": [
      {
        "id": "register-order",
        "label": "Register order",
        "stateHash": "f184659e",
        "focusLetter": "ה",
        "confidence": 0.857,
        "rationale": "Reads the manifested registers in machine order."
      },
      {
        "id": "mirror-order",
        "label": "Mirror order",
        "stateHash": "ef3a0b7f",
        "focusLetter": "צ",
        "confidence": 0.82,
        "rationale": "Reads the same state through its paired-register reflection."
      },
      {
        "id": "phase-offset",
        "label": "Aleph Olam phase",
        "stateHash": "ef846278",
        "focusLetter": "כ",
        "confidence": 0.825,
        "rationale": "Projects the state through the shared Aleph Olam orientation."
      }
    ],
    "selectedProjection": "mirror-order",
    "snapshot": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      0
    ]
  }
}
